/// <reference types="vite/client" />

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
  interface ImportMetaEnv {
    readonly VITE_GA_TAG: string
  }
}

export {}

/**
 * Initialize Google Analytics with enhanced measurement
 */
export const initAnalytics = () => {
  const gaTag = import.meta.env.VITE_GA_TAG;
  if (!gaTag) {
    console.warn('Google Analytics Tag not found in environment variables');
    return;
  }

  // Create and append GA script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaTag}`;
  document.head.appendChild(script);

  // Initialize dataLayer and gtag function
  window.dataLayer = window.dataLayer || [];
  window.gtag = function(){window.dataLayer.push(arguments);}

  // Initialize GA with enhanced measurement
  window.gtag('js', new Date());
  window.gtag('config', gaTag, {
    send_page_view: true,
    cookie_flags: 'max-age=7200;secure;samesite=none',
    transport_url: 'https://www.google-analytics.com',
    transport_type: 'beacon'
  });
};

/**
 * Track a custom event in Google Analytics
 * @param eventName The name of the event to track
 * @param eventParams Additional parameters for the event
 */
export const trackEvent = (eventName: string, eventParams: Record<string, any> = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

/**
 * Track a page view in Google Analytics with enhanced engagement tracking
 * @param pagePath The path of the page being viewed
 */
export const trackPageView = (pagePath: string) => {
  const gaTag = import.meta.env.VITE_GA_TAG;
  if (window.gtag && gaTag) {
    window.gtag('config', gaTag, {
      page_path: pagePath,
      page_title: document.title,
      user_engagement: true
    });
  }
};

/**
 * Track user engagement time manually (for SPA navigation)
 */
export const trackEngagement = () => {
  if (window.gtag) {
    window.gtag('event', 'user_engagement', {
      engagement_time_msec: 1000,
      session_id: window.sessionStorage.getItem('ga_session_id')
    });
  }
};
